<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane v-if="visibleDatosFamiliares" key="1">
          <span slot="tab">
            <a-icon type="user"/>
            {{$t('Datos familiares')}}
          </span>
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-card>
              <g-master name="coc"
                        :endpoint="master.endpoint"
                        :tableSetup="master.tableSetup"
                        :modalFieldsSetup="master.modalFieldsSetup"
                        modalWidth="90%"
                        :parentData="evParentData"
                        @action="masterAction"
                        :beforeSend="master.beforeSend"
                        ref="masterComponent"
              >
                <template slot="expandedRowRender" slot-scope="{text}">
                  <template v-for="ve in master.valoresExpandidos">
                    {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
                  </template>
                </template>

                <template slot="masterModal" slot-scope="{record}">
                  <a-row :gutter="[16,16]">
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Nombre')">
                        <a-input
                          class="ant-uppercase"
                          v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Primer apellido')">
                        <a-input
                          class="ant-uppercase"
                          v-decorator="['last_name1', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Segundo apellido')">
                        <a-input
                          class="ant-uppercase"
                          v-decorator="['last_name2', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Cédula de familiar')">
                        <a-input
                          class="ant-uppercase"
                          v-decorator="['id_number', { rules: [{ required:required_id_number, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Fecha de nacimiento')">
                        <a-date-picker style="width: 100%"
                                       type="date"
                                       valueFormat="Y-MM-DD HH:mm:ss"
                                       v-decorator="['date_birth', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        ></a-date-picker>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Edad')">
                        <a-tag color="blue"
                               style="height: 32px;
                           padding-top: 4px;width: 100%;">
                          <a-icon type="gift"/>
                          {{edad}}
                        </a-tag>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="hierarchy_lookup"
                                  :label="$t('Parentesco')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['id_h_relationship', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                                  :params="id_h_relationship">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="hierarchy_lookup"
                                  :label="$t('Grupo sanguíneo')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['id_h_blood_group', { rules: [{ required: false}] }]"
                                  :params="id_h_blood_group"
                                  :disabled="isDisabledGrupoSanguineo">
                      </g-dropdown>
                    </a-col>

                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="hierarchy_lookup"
                                  :label="$t('Factor RH')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['id_h_blood_rh', { rules: [{ required: false}] }]"
                                  :params="id_h_blood_rh"
                                  :disabled="isDisabledFactorRH">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="hierarchy_lookup"
                                  :label="$t('Género')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['gender', { rules: [{ required: false}] }]"
                                  :params="sexo">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="hierarchy_lookup"
                                  :label="$t('Estado civil')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['id_h_marital_status', { rules: [{ required: false}] }]"
                                  :params="id_h_marital_status">
                      </g-dropdown>
                    </a-col>
                    <a-col v-if="mostrarDepartamento" v-bind="colOptions">
                      <g-dropdown endpoint="hierarchy_lookup"
                                  :label="$t('Departamento')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['departamento', { rules: [{ required: false}] }]"
                                  :params="{h_lookup_type: 'DEPARTAMENTOS'}"
                                  :disabled="isDisabledDepartamento">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <g-lookup endpoint="hierarchy_lookup" :selectedObj.sync="localizacion.ciudad"
                                :label="$t('Ciudad de nacimiento')"
                                :formItemConfig="fiOptions"
                                :decorator="['id_h_city_birth', { rules: [{ required: false}] }]"
                                :params="{h_lookup_type: 'CIUDADES'}"
                                ref="city"
                                :disabled="isDisabledCiudadNacimiento"
                      >
                      </g-lookup>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Dirección')">
                        <a-textarea placeholder="Dirección"
                                    class="ant-uppercase"
                                    readOnly
                                    autoSize
                                    v-model="address"
                                    v-on:click="modalDireccionVisible = true">
                        </a-textarea>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Barrio')">
                        <a-input
                          class="ant-uppercase"
                          v-decorator="['neighborhood', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Teléfono')">
                        <a-input
                          class="ant-uppercase"
                          v-decorator="['phone', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Celular')">
                        <a-input
                          class="ant-uppercase"
                          v-decorator="['cellphone', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-if="mostrarDepartamento" v-bind="colOptions">
                      <a-form-item :label="$t('Compañía')">
                        <a-input
                          class="ant-uppercase"
                          v-decorator="['company', { rules: [{ required: false}] }]"
                          :disabled="isDisabledCompany"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-if="mostrarDepartamento" v-bind="colOptions">
                      <a-form-item :label="$t('Cargo')">
                        <a-input
                          class="ant-uppercase"
                          v-decorator="['job', { rules: [{ required: false}] }]"
                          :disabled="isDisabledCargo"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Aspectos familiares')" v-if="mostrarAspectosFamiliares || !$userIsInrol('SelfService')">
                        <a-textarea autoSize
                                    v-decorator="['family_aspects', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Beneficiario')" v-show="mostrarBeneficiario || !$userIsInrol('SelfService')" :has-feedback="false">
                        <a-checkbox
                          v-decorator="['beneficiary', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                        </a-checkbox>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('UPC')" v-show="mostrarUPC || !$userIsInrol('SelfService')" :has-feedback="false">
                        <a-checkbox
                          v-decorator="['upc', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                        </a-checkbox>
                      </a-form-item>
                    </a-col>
                    <a-col  v-bind="colOptions">
                      <a-form-item v-show="isUPCTrue" :label="$t('UPC valor')">
                        <a-input-number
                          style="width: 100%"
                          v-decorator="['upc_value', { rules: [{ required: false}] }]"/>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </template>
              </g-master>
            </a-card>
          </a-col>
        </a-row>
      </a-tab-pane>
      <a-tab-pane v-if="visibleFamiliaresEnOrganizacion" key="2">
          <span slot="tab">
            <a-icon type="user"/>
            Familiares en la organización
          </span>
        <a-row>
          <a-col :span="24">
            <a-card>
              <g-master name="coc"
                        :endpoint="foMaster.endpoint"
                        :tableSetup="foMaster.tableSetup"
                        :modalFieldsSetup="foMaster.modalFieldsSetup"
                        :parentData="evParentData"
              >
                <template slot="masterModal" slot-scope="{record}">
                  <a-row :gutter="[16,16]">
                    <a-col v-bind="col2Options">
                      <a-form-item :label="$t('Nombre')">
                        <a-input
                          class="ant-uppercase"
                          v-decorator="['full_name', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="col2Options">
                      <g-dropdown endpoint="jobs"
                                  style="width: 100%"
                                  :formItemConfig="fiOptions"
                                  :label="$t('Cargo')"
                                  :decorator="['job', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      >
                      </g-dropdown>
                    </a-col>
                  </a-row>
                </template>
              </g-master>
            </a-card>
          </a-col>
        </a-row>
      </a-tab-pane>
      <direccion-estructurada v-model="address" :visible="modalDireccionVisible"
                              @cancel="modalDireccionVisible = false"
                              @success="direccionCambiada"></direccion-estructurada>
    </a-tabs>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'

  export default {

    data () {
      return {
        isDisabledGrupoSanguineo: this.$getConfigValue('BIODATA_FAM_ID_H_BLOOD_GROUP_DISABLED', false) === 'SI',
        isDisabledFactorRH: this.$getConfigValue('BIODATA_FAM_ID_H_BLOOD_RH_DISABLED', false) === 'SI',
        isDisabledDepartamento: this.$getConfigValue('BIODATA_FAM_DEPARTAMENTO_DISABLED', false) === 'SI',
        isDisabledCiudadNacimiento: this.$getConfigValue('BIODATA_FAM_ID_H_CITY_BIRTH_DISABLED', false) === 'SI',
        isDisabledCompany: this.$getConfigValue('BIODATA_FAM_COMPANY_DISABLED', false) === 'SI',
        isDisabledCargo: this.$getConfigValue('BIODATA_FAM_JOB_DISABLED', false) === 'SI',
        localizacion: {
          departamento: {},
          ciudad: {}
        },
        mostrarDepartamento: this.$getConfigValue('OCULTAR_ASPIRACION_RECLUTAMIENTO_BIODATA', 'SI') === 'NO',
        edad: null,
        address: null,
        modalDireccionVisible: false,
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        isUPCTrue: false,
        id_h_relationship: {
          h_lookup_type: 'PARENTESCO'
        },
        id_h_city_birth: {
          h_lookup_type: 'CIUDADES'
        },
        id_h_blood_group: {
          h_lookup_type: 'GRUPO_SANGUINEO'
        },
        id_h_blood_rh: {
          h_lookup_type: 'RH'
        },
        id_h_marital_status: {
          h_lookup_type: 'ESTADO_CIVIL'
        },
        sexo: {
          h_lookup_type: 'SEXO',
          use_code: true
        },
        colOptions: {xs: 24, sm: 8},
        col2Options: {xs: 24, sm: 24},
        master: {
          beforeSend: (data) => {
            data.address = this.address
            return data
          },
          valoresExpandidos: [
            {label: 'Fecha de nacimiento', column: 'fecha_nacimiento'},
            {label: 'Ciudad de nacimiento', column: 'h_city_birth'},
            {label: 'Grupo sanguíneo', column: 'h_blood_group'},
            {label: 'Factor RH', column: 'h_blood_rh'},
            {label: 'Género', column: 'upc_genero'},
            {label: 'Estado civil', column: 'h_marital_status'},
            {label: 'Dirección', column: 'address'},
            {label: 'Barrio', column: 'neighborhood'},
            {label: 'Teléfono', column: 'phone'},
            {label: 'Empresa', column: 'company'},
            {label: 'Cargo', column: 'job'},
            {label: 'Aspectos familiares', column: 'family_aspects'},
            {label: 'Beneficiario', column: 'beneficiary_desc'},
            {label: 'UPC', column: 'upc_desc'},
            {label: 'UPC valor', column: 'upc_value'}
          ],
          endpoint: 'personfamily',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id_person_family'
            },
            columns: [
              {title: 'Cédula', dataIndex: 'id_number', sorter: true},
              {title: 'Nombre', dataIndex: 'full_name', sorter: true},
              {title: 'Celular', dataIndex: 'cellphone', sorter: true},
              {title: 'Parentesco', dataIndex: 'h_relationship', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by'},
              {title: 'Creado', dataIndex: 'created_on'},
              {title: 'Modificado por', dataIndex: 'modified_by'},
              {title: 'Modificado', dataIndex: 'modified_on'}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_number'},
            {name: 'name'},
            {name: 'last_name1'},
            {name: 'last_name2'},
            {name: 'id_h_relationship'},
            {name: 'id_h_city_birth'},
            {name: 'id_h_blood_group'},
            {name: 'id_person'},
            {name: 'date_birth'},
            {name: 'id_h_blood_rh'},
            {name: 'gender'},
            {name: 'id_h_marital_status'},
            {name: 'address'},
            {name: 'neighborhood'},
            {name: 'phone'},
            {name: 'cellphone'},
            {name: 'company'},
            {name: 'job'},
            {name: 'beneficiary'},
            {name: 'id_number'},
            {name: 'upc'},
            {name: 'upc_value'},
            {name: 'departamento'},
            {name: 'family_aspects'}
          ]
        },
        foMaster: {
          endpoint: 'personfamilyorg',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_person_family_org'
            },
            columns: [
              {title: 'Nombre', dataIndex: 'full_name', sorter: true},
              {title: 'Cargo', dataIndex: 'job_name', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by'},
              {title: 'Creado el', dataIndex: 'created_on'},
              {title: 'Modificado por', dataIndex: 'modified_by'},
              {title: 'Modificado', dataIndex: 'modified_on'}
            ]
          },
          modalFieldsSetup: [
            {name: 'full_name'},
            {name: 'job'}
          ]
        },
        mostrarUPC: this.$getConfigValue('BIODATA_DATOS_FAMILIARES_MOSTRAR_UPC', 'SI') === 'SI',
        mostrarAspectosFamiliares: this.$getConfigValue('BIODATA_DATOS_FAMILIARES_ASPECTOS_FAM', 'SI') === 'SI',
        mostrarBeneficiario: this.$getConfigValue('BIODATA_DATOS_FAMILIARES_MOSTRAR_BENEFICIARIO', 'SI') === 'SI',
        required_id_number: this.$getConfigValue('BIODATA_REQUERIDO_ID_NUMBER', 'SI') !== 'NO'
      }
    },
    methods: {
      direccionCambiada () {
        this.modalDireccionVisible = false
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.address = ''
            break
          case 'masterEdit':
            if (!JsUtils.isEmpty(action.record.edad)) {
              this.edad = action.record.edad
            }
            if (!JsUtils.isEmpty(action.record.address)) {
              this.address = action.record.address
            }
            if (!JsUtils.isEmpty(action.record.upc)) {
              this.isUPCTrue = action.record.upc
            }
            if (!JsUtils.isEmpty(action.record.id_h_city_birth)) {
              this.$refs.city && this.$refs.city.handleSearch(action.record.id_h_city_birth)
            }
            break
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!JsUtils.isEmpty(action.changedFields.upc)) {
              if (action.changedFields.upc.value) {
                this.isUPCTrue = true
              } else {
                this.isUPCTrue = false
              }
            }
            break
        }
      }
    },
    props: ['persona'],
    computed: {
      visibleFamiliaresEnOrganizacion () {
        let existeParametro = this.$getConfigValue('PARAMETRIZAR_TABS_HOJA_VIDA')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          return true
        } else {
          return this.$userIsInrol('BIO_FAMILIARES_ORGANIZACION')
        }
      },
      visibleDatosFamiliares () {
        let existeParametro = this.$getConfigValue('BIO_DATOS_FAMILIARES')
        if (this.$isEmpty(existeParametro) || existeParametro === 'NO' || this.$userIsInrol('Management')) {
          return true
        } else {
          return this.$userIsInrol('HV_ATRIBUTOS_CARACTER')
        }
      },
      evParentData () {
        return {
          id_person: this.persona
        }
      },
      deptoParams () {
        return {h_lookup_type: 'DEPARTAMENTOS'}
      },
      ciudadParams () {
        return {h_lookup_type: 'CIUDADES', id_h_lookup_father: this.localizacion.departamento.value}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataDatosFamiliares.vue